import styled from 'styled-components'
import { DeviceTypes } from '../../../types/state'

export const OTPVerificationWrapper = styled.div<{ device: DeviceTypes }>`
	justify-content: space-evenly;
	display: flex;
	flex-flow: column;
	// height: var(--el-hg-lg);
	// background-color: var(--form-bg-color);
	// border-radius: var(--border-radius-lg);

	width: ${({ device }) => (device === DeviceTypes.MOBILE ? '100%' : '40%')};
	margin-left: auto;
	margin-right: auto;
`

export const OTPHeader = styled.div`
	display: flex;
	justify-content: space-between;
	padding: 0% 5%;
`

export const PhoneNumberWrapper = styled.div`
	font-size: var(--fs-xs);
	font-weight: var(--fw-sm);
	letter-spacing: 0.9px;
`

export const ColorSpan = styled.span`
	color: var(--btn-color);
	margin-top: 25px;
	margin-bottom: 35px;
`
export const ChangeWrapper = styled.div`
	font-size: var(--fs-xxs);
	color: var(--btn-color);
	font-weight: var(--fw-sm);
	cursor: pointer;
`

export const OTPWrapper = styled.div`
	// height: 20vh;
	display: flex;
	flex-flow: column;
	justify-content: space-around;
`

export const OTPText = styled.div`
	font-size: var(--fs-xxs);
	letter-spacing: 0.9px;
	color: var(--text-info-color);
`
export const OTPInputWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 15px;
`

export const OTPInput = styled.input`
	width: 35px;
	height: 45px;
	margin: 5px;
	background-color: transparent;
	border: 0px;
	border-bottom: 1px solid var(--border-color);
	font-size: 35px;
	text-align: center;
	color: #ffb400;
	appearance: none;
	&::-webkit-outer-spin-button,
	&::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}
	&:focus {
		outline: none;
		border-bottom: 1px solid #ffb400;
	}
`

export const Heading = styled.h1`
	font-size: 24px;
	color: white;
`
